/* unplugin-vue-components disabled */import { render } from "./scroll-bar.vue?vue&type=template&id=aef7d4fc&scoped=true&ts=true"
import script from "./scroll-bar.vue?vue&type=script&lang=ts"
export * from "./scroll-bar.vue?vue&type=script&lang=ts"

import "./scroll-bar.vue?vue&type=style&index=0&id=aef7d4fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef7d4fc"]])

export default __exports__